import cn from 'classnames';
import { FC, KeyboardEvent } from 'react';
import { Portal, Tooltip } from '@datassential/platform-ui-lib';
import Icon from '@components/Icon/Icon';
import { IconCheck } from '@icons';
import { SELECT_ALL_MAX, SelectAllState } from '../selectAll';

export type SelectAllCheckboxProps = {
    state: SelectAllState;
    onClick: () => void;
};

const TOOLTIP_ID = 'tooltip-top-trends-select-all';
const TOOLTIP_TEXT = `select all (max ${SELECT_ALL_MAX})`;

const ARIA_CHECKED: Record<SelectAllState, boolean | 'mixed'> = {
    checked: true,
    partial: 'mixed',
    empty: false,
};

/** Header checkbox that selects (or clears) the keywords in the Top Trends table. */
const SelectAllCheckbox: FC<SelectAllCheckboxProps> = ({ state, onClick }) => {
    /** Toggles the checkbox once per Space or Enter press (key repeats are ignored), like a native checkbox. */
    const handleKeyDown = (e: KeyboardEvent<HTMLDivElement>) => {
        if (!e.repeat && (e.key === ' ' || e.key === 'Enter')) {
            e.preventDefault();
            onClick();
        }
    };

    return (
        <>
            <div
                className="TopTrendsKeywordCell__checkbox-container TopTrendsKeywordCell__checkbox-container--visible TopTrendsTable__select-all"
                role="checkbox"
                aria-checked={ARIA_CHECKED[state]}
                aria-label="select all"
                data-tooltip-id={TOOLTIP_ID}
                data-testid="topTrendsSelectAll"
                tabIndex={0}
                onClick={onClick}
                onKeyDown={handleKeyDown}
            >
                <span
                    className={cn(
                        'TopTrendsKeywordCell__checkbox-icon',
                        state === 'checked' && 'TopTrendsKeywordCell__checkbox-icon--checked',
                        state === 'partial' && 'TopTrendsKeywordCell__checkbox-icon--partial',
                    )}
                >
                    <Icon type="small">
                        <IconCheck/>
                    </Icon>
                </span>
            </div>
            <Portal>
                <Tooltip id={TOOLTIP_ID} place="top">
                    {TOOLTIP_TEXT}
                </Tooltip>
            </Portal>
        </>
    );
};

export default SelectAllCheckbox;
